export default "__VITE_ASSET__lZ7BJMt5__"